import React, { FunctionComponent } from 'react';

interface ListButtonsContainerProps {
  children?: React.ReactNode;
}

export const ListButtonsContainer: FunctionComponent<ListButtonsContainerProps> = ({ children }) => {
  return <ul className="space-y-2">{children}</ul>;
};
